import { withLazyLoading } from '@atlaskit/editor-common/lazy-node-view';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { taskItemNodeViewFactory } from './taskItem';
import { TaskItemNodeView } from './TaskItemNodeView';
export var taskView = function taskView(portalProviderAPI, eventDispatcher, providerFactory, api, intl, placeholder) {
  if (editorExperiment('platform_editor_vanilla_dom', true, {
    exposure: true
  })) {
    return function (node, view, getPos) {
      return new TaskItemNodeView(node, view, getPos, {
        placeholder: placeholder,
        api: api,
        intl: intl
      });
    };
  }
  if (editorExperiment('platform_editor_exp_lazy_node_views', false)) {
    return taskItemNodeViewFactory(portalProviderAPI, eventDispatcher, providerFactory, api, intl, placeholder);
  }
  return withLazyLoading({
    nodeName: 'taskItem',
    getNodeViewOptions: function getNodeViewOptions() {},
    loader: function loader() {
      var result = import( /* webpackChunkName: "@atlaskit-internal_editor-plugin-tasks-and-decisions_task-item-nodeview" */
      './taskItem').then(function (_ref) {
        var taskItemNodeViewFactory = _ref.taskItemNodeViewFactory;
        return function (node, view, getPos) {
          return taskItemNodeViewFactory(portalProviderAPI, eventDispatcher, providerFactory, api, intl, placeholder)(node, view, getPos);
        };
      });
      return result;
    }
  });
};